import * as Yup from 'common/yup';
import {diplomatObjectSchema} from './diplomat-object';

export const keySettingsSchema = diplomatObjectSchema.shape({
   additionalEncryptionKeyId: Yup.idString(),
   decryptionKeyId: Yup.idString(),
   signatureKeyId: Yup.idString(),
});

export type KeySettings = Yup.InferType<typeof keySettingsSchema>;
